/* eslint-disable import/no-named-as-default */
import CompanySettingBar from './company_setting_bar';

export default CompanySettingBar;
